import { initializeRequestVerification } from '~/utils/requestVerification'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', () => {
    void initializeRequestVerification()
  })
})
